/**
 * Clarity utility functions for user identification
 * Handles identifying users and clearing identification to avoid cross-contamination
 */

import Clarity from "@microsoft/clarity";

/**
 * Identify a user in Microsoft Clarity
 * @param {Object} client - Client object with id, name, phone, email
 */
export const identifyClarityUser = (client) => {
  try {
    // Use client ID as the unique identifier
    const clarityId = `client_${client.id}`;
    const friendlyName = client.name || "Unknown";
    
    // Set metadata using setTag for additional properties
    if (client.phone) Clarity.setTag("phone", client.phone);
    if (client.email) Clarity.setTag("email", client.email);
    if (client.siteId) Clarity.setTag("siteId", client.siteId);
    Clarity.setTag("clientId", client.id);
    Clarity.setTag("clientName", friendlyName);
    
    console.log("[Clarity] Identifying user:", {
      clarityId,
      clientId: client.id,
      clientName: friendlyName,
      phone: client.phone || "",
      email: client.email || "",
      siteId: client.siteId || null,
      timestamp: new Date().toISOString(),
    });
    
    // Identify with customerId and friendlyName
    // Parameters: identify(customerId, customSessionId, customPageId, friendlyName)
    Clarity.identify(clarityId, null, null, friendlyName);
  } catch (error) {
    console.error("[Clarity] Error identifying user:", error);
  }
};

/**
 * Clear user identification in Microsoft Clarity
 * This should be called when a user session ends or before identifying a new user
 */
export const clearClarityUser = (reason) => {
  try {
    console.log("[Clarity] Clearing user identification", {
      reason: reason || "Unknown",
      timestamp: new Date().toISOString(),
    });
    
    // Clear tags
    Clarity.setTag("clientId", null);
    Clarity.setTag("clientName", null);
    Clarity.setTag("phone", null);
    Clarity.setTag("email", null);
    Clarity.setTag("siteId", null);
    
    // Identify as anonymous user
    Clarity.identify("anonymous_user", null, null, "Anonymous");
  } catch (error) {
    console.error("[Clarity] Error clearing user:", error);
  }
};

